export default "__VITE_ASSET__CW$zEZ4m__"